import TopHeader from "../../Component/Header/TopHeader";
import { useFieldArray, useForm } from "react-hook-form";
import React, { useCallback, useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { FormHelperText, TextField, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import { FormControlLabel, Checkbox } from "@mui/material";
import { useRemoveAdminMutation, useSaveChapterMutation } from "../../app/services/chapterServices";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetChapterDetailsByIdQuery } from "../../app/services/chapterServices";
import { useUpdateChapterMutation } from "../../app/services/chapterServices";
import { Editor } from "primereact/editor";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import Spinner from "../../Component/spinner/spinner";
import { Typography } from "@mui/material";
import { Controller } from 'react-hook-form';
import placeholder from '../../assets/images/placeholder/placeholder.png'
import { Country, State } from "country-state-city";
import { Salutation } from "../../constant/constant";
import { selectCurrentScope, selectUserId } from "../../app/auth/authSlice";
import { useSelector } from "react-redux";
import ImageCropModal, { useImageCrop } from "../../Component/ImageCropModal/ImageCropModal";

const ChapterForm = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); //route
  const [initialData, setInitalData] = useState([]);
  const [removeMemberAdmin] = useRemoveAdminMutation();
  const countries = Country.getAllCountries();
  const [isAdmin, setIsAdmin] = useState(null);
  const memberScope = useSelector(selectCurrentScope);
  const userId = useSelector(selectUserId);
  const [updateChapter] = useUpdateChapterMutation(); //API for Update
  // Tracks whether descriptionText has been seeded from the API response.
  // Prevents removeRoleDetails → setChapterData → useEffect from overwriting
  // the user's in-progress description edits.
  const descriptionInitialized = React.useRef(false);


  // Crop Hooks
  const {
    cropModal: logoCropModal,
    openCropModal: openLogoCropModal,
    handleCropApply: handleLogoCropApply,
    closeCropModal: closeLogoCropModal
  } = useImageCrop();

  const {
    cropModal: roleCropModal,
    openCropModal: openRoleCropModal,
    handleCropApply: handleRoleCropApply,
    closeCropModal: closeRoleCropModal
  } = useImageCrop();

  //chapterForm Initialization
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    watch,
    trigger,
    formState: { errors },

    control,
  } = useForm({
    mode: 'onChange', // Validate on form submission initially
    reValidateMode: 'onChange',
    defaultValues: {
      countryCategory: '',
      country: "",
      state: "",
      title: "",
      district: "",
      establishedOn: '',
      imageUrl: "",
      roleDetails: [],
      removedAdminEmail: [],
      chapterUrl: '',
      adminsId: [],
      createdBy: {
        id: "",
        role: "",
      },//required
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "roleDetails",
  });
  const states = watch('country')
    ? State.getStatesOfCountry(watch('country'))
    : [];
  // Adding a new empty object to roleDetails array when "Add Office Bearers" button is clicked
  const addRoleDetails = () => {
    append({
      role: "",
      salutation: '',
      name: "",
      designation: '',
      institution: '',
      address: "",
      pincode: '',
      mobile: "",
      email: "",
      roleImageUrl: "",
      isAdmin: false,
      password: "",
    });
  };

  // Removing Roledetails for each row except the first one
  const removeRoleDetails = (index) => {
    setValue(`roleDetails.${index}.isAdmin`, false);
    const isAdmin = getValues(`roleDetails.${index}.isAdmin`)
    const roleDetail = getValues(`roleDetails.${index}`)
    const allChapterData = getValues()
    if (chapterId) {
      // Make a shallow copy of the roleDetails array
      const newData = [...allChapterData?.roleDetails];
      // Remove the element at the specified index
      newData.splice(index, 1);
      // Create a new object with the updated roleDetails array
      const newChapter = { ...allChapterData, roleDetails: newData };
      setChapterData(newChapter);
    }
    if (isAdmin) {
      removeAdmin(roleDetail, index)
    }
    else {
      remove(index);
    }
  };

  //Remove admin
  const removeAdmin = (member, index) => {
    const data = {
      chapterId,
      roleId: member._id,
      email: member.email,
    };
    setLoading(true);
    removeMemberAdmin(data).then((res) => {
      if (res.data?.data) {
        remove(index);
        setLoading(false);
        toast.success(res.data?.message);
      } else {
        setLoading(false);
        toast.error(res.data?.err?.message);
      }
    });
  };

  const [saveChapter] = useSaveChapterMutation(); //calling save API service
  const { chapterId } = useParams(); //get Id from params
  const [chapterDetailById] = useLazyGetChapterDetailsByIdQuery(); //calling getby chapter id API service
  const [chapterData, setChapterData] = useState(null); //state for get id data
  const [selectedImage, setSelectedImage] = useState();
  const [selectedRoleImage, setSelectedRoleImage] = useState([]);
  const [fullUrl, setFullUrl] = useState("");
  const [descriptionText, setDescriptionText] = useState("");

  //get by id
  const fetchChapterData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await chapterDetailById(chapterId);
      if (response.data.status) {
        setLoading(false);
        setChapterData(response.data.data); // Update the state with the fetched data
        setInitalData(response.data?.data);
      } else {
        setLoading(false);
        toast.error(response.data?.err?.message);
      }
    } catch (error) {
      toast.error(error);
    }
  }, [chapterDetailById, chapterId]);
  useEffect(() => {
    if (chapterId) {
      fetchChapterData(); // Call the function to fetch chapter data
    }
  }, [fetchChapterData, chapterId]);

  // Patch form values from chapterData
  useEffect(() => {
    if (chapterData) {
      setValue("title", chapterData.title);
      setValue("state", chapterData.state);
      setValue('country', countries.find(c => c.name === chapterData?.country)?.isoCode || chapterData?.country)
      setValue('countryCategory', chapterData?.countryCategory)
      setValue("chapterUrl", chapterData.chapterUrl)
      setValue('district', chapterData?.district)
      setValue('establishedOn', chapterData?.establishedOn ? chapterData?.establishedOn.split('T')[0] : '')
      setValue("imageUrl", chapterData.imageUrl)
      // Only seed description from the server on the very first load.
      // Later calls to setChapterData (e.g. from removeRoleDetails) must NOT
      // overwrite what the user is currently typing in the editor.
      if (!descriptionInitialized.current) {
        setDescriptionText(chapterData.description || "");
        descriptionInitialized.current = true;
      }
      if (chapterData.roleDetails.length !== 0) {
        setValue("roleDetails", chapterData.roleDetails);
      }
      const roleImages = chapterData.roleDetails.map(
        (item) => item.roleImageUrl
      );
      setSelectedRoleImage(roleImages);
    }
  }, [chapterData, countries, setValue]);

  //Form submit
  const handleFormSubmit = async (formData) => {
    setLoading(true);
    formData.description = descriptionText;
    if (chapterId) {
      const formRoleDetailsIds = formData.roleDetails.map(
        (role) => role._id
      );
      const filteredData = initialData?.roleDetails?.filter((item) => {
        const isIncluded = formRoleDetailsIds.includes(item._id);
        return !isIncluded;
      });
      const isAdminStatus = filteredData.filter(
        (item) => item.isAdmin === true
      );
      const email = filteredData.map((item) => item.email);
      setValue("removedAdminEmail", email);
      formData.removedAdminEmail = watch("removedAdminEmail")
      if (isAdminStatus) {
        const userId = isAdminStatus.map(item => item.userId)
        setValue("removedUserId", userId);
        setValue("adminsId", initialData.adminsId);
        formData.adminsId = watch("adminsId")
        formData.removedUserId = watch("removedUserId")
        const base64Regex =
          /^data:image\/(?:png|jpeg|jpg|gif);base64,[\w+/=]+$/;
        formData.imageUrl = base64Regex.test(formData.imageUrl)
          ? formData.imageUrl
          : formData?.imageUrl.split("/").slice(-2).join("/");
        formData.roleDetails = formData.roleDetails.map((item) => {
          return {
            ...item,
            roleImageUrl: base64Regex.test(item.roleImageUrl)
              ? item.roleImageUrl
              : item.roleImageUrl?.split("/").slice(-3).join("/"),
          };
        });
        const updatedData = { ...formData, country: countries.find(c => c.isoCode === formData.country)?.name }
        const data = { id: chapterId, formData: updatedData };

        try {
          const res = await updateChapter(data);
          if (res.data.status) {
            setLoading(false);
            toast.success(res.data?.message);
            navigate("/view-Chapter");
          } else {
            setLoading(false);
            toast.error(res.data?.err?.message);
          }
        } catch (error) {
          setLoading(false);
          toast.error("Failed to update chapter" + error);
        }
      }
    }
    //Save Chapter API
    else {
      const updatedData = { ...formData, country: countries.find(c => c.isoCode === formData.country).name }
      updatedData.createdBy = {
        id: userId,
        role: memberScope,
      };
      saveChapter(updatedData).then((res) => {
        if (res.data.status) {
          setLoading(false);
          toast.success(res.data?.message)
          navigate("/view-Chapter"); // Navigate after the success message disappears
        } else {
          setLoading(false);
          toast.error(res.data?.err?.message)
        }
      });
    }
  };

  const handleImageFileChange = (event) => {
    openLogoCropModal(event, null, 5);
  };

  const handleRoleImageFileChange = (event, index) => {
    openRoleCropModal(event, index, 5);
  };

  const handleUrlChange = (value) => {
    if (value) {
      setFullUrl(`${window.location.origin}/chapter/${value}`);
    } else {
      setFullUrl("");
    }
  };


  return (
    <div>
      <TopHeader />
      {chapterId ? (
        <div className="pt-5">
          <div className="chapter-heading">
            <h2 className="text-center title-font text-light py-3 mt-1">Edit Chapter</h2>
          </div>
        </div>) : (
        <div className="pt-5">
          <div className="chapter-heading">
            <h2 className="text-center title-font text-light py-3 mt-1">Add Chapter</h2>
          </div>
        </div>
      )}
      {loading ? (
        <Spinner />
      ) : (
        <form onSubmit={handleSubmit(handleFormSubmit)} className="p-md-5 p-3 overallPadding">
          <div className="text-end mb-3">
            <Button
              onClick={() => window.history.back()}
              variant="contained"
              className="menus-color"
              style={{ float: "right" }}>
              Back
            </Button>
          </div>
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item xs={12} md={6} lg={4} className="d-flex justify-content-between">
              <Controller className='w-100' rules={{ required: "Please select country category" }} control={control} name="countryCategory" render={({ field, fieldState }) => (
                <FormControl className="w-100">
                  <InputLabel id='state-label'>
                    <span className="text-dark">Country Category</span>
                    <span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    id="State"
                    labelId="state-label"
                    fullWidth
                    label={<span className="text-black">Country Category <span className="text-danger">*</span></span>}
                    value={field?.value || ""}
                    onChange={(e) => {
                      field.onChange(e.target.value)
                      if (e.target.value === 'India') {
                        setValue('country', 'IN', { shouldValidate: true })
                      }
                      else {
                        setValue('country', '')
                      }
                    }}
                    error={!!fieldState.error}
                  >
                    <MenuItem value={'India'}>
                      India
                    </MenuItem>
                    <MenuItem value={'Overseas'}>
                      Overseas
                    </MenuItem>
                  </Select>
                  <FormHelperText className="text-danger">
                    {fieldState?.error?.message}
                  </FormHelperText>
                </FormControl>
              )} />
            </Grid>
            <Grid item lg={4} md={6} xs={12}>
              <FormControl
                fullWidth
                className="mt-0"
                error={!!errors.country}
                disabled={watch('countryCategory') === 'India'}
              >
                <InputLabel className="text-dark">
                  Country <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  name="country"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Please select a country", // Validation rule
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      className="bg-white"
                      label={
                        <Typography className="text-dark">
                          Country <span style={{ color: "red" }}>*</span>
                        </Typography>
                      }
                      value={field.value || ''}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                        setValue("state", "");
                      }}
                    >
                      <MenuItem value="">
                        <em>Select Country</em>
                      </MenuItem>
                      {countries.map((country) => (
                        <MenuItem
                          key={country.isoCode}
                          value={country.isoCode}
                        >
                          {country.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                {errors.country && (
                  <FormHelperText>
                    {errors.country.message}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item lg={4} md={6} xs={12}>
              <FormControl
                fullWidth
                disabled={!watch("country")}
                error={!!errors.state}
              >
                <InputLabel className="text-dark">
                  State<span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Controller
                  name="state"
                  control={control}
                  rules={{
                    required: watch("country") && "Please select a state", // Only required if a country is selected
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      label={
                        <Typography className="text-dark">
                          State <span style={{ color: "red" }}>*</span>
                        </Typography>
                      }
                      readOnly={!watch('country')}
                      value={field.value || ''}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                    >
                      <MenuItem value="">
                        <em>Select State</em>
                      </MenuItem>
                      {states.map((state) => (
                        <MenuItem key={state.isoCode} value={state.name}>
                          {state.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                {errors.state && (
                  <FormHelperText>{errors.state.message}</FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                InputLabelProps={{ shrink: true }}
                helperText={errors?.district?.message}
                fullWidth
                error={!!errors?.district}
                id="district"
                placeholder="Enter chapter district"
                label={
                  <Typography className="text-dark">
                    District <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                {...register("district", { required: "Please enter a district" })}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                InputLabelProps={{ shrink: true }}
                helperText={errors?.title?.message}
                error={!!errors?.title}
                fullWidth
                id="title"
                placeholder="Enter chapter name"
                label={
                  <Typography className="text-dark">
                    Name of the Chapter <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                {...register("title", { required: "Please enter name", maxLength: { value: '35', message: 'Please enter chapter name less than 35 letters' } })}
              />
            </Grid>
            <Grid item lg={4} md={6} xs={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                id="establishedOn"
                label={
                  <Typography className="text-dark">
                    Established On <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                inputProps={{
                  max: new Date().toISOString().split("T")[0],
                }}
                {...register("establishedOn", {
                  required: "Please select a date which chapter is established", validate: (value) => {
                    const year = new Date(value).getFullYear().toString();
                    if (year.length > 4) {
                      return "Year cannot exceed 4 digits";
                    }
                    return true;
                  }, max: { value: new Date().toISOString().split("T")[0], message: 'Please select past or present date' }
                })}
                error={!!errors?.establishedOn}
                helperText={errors?.establishedOn?.message}
              />
            </Grid>
            {<Grid item xs={12} md={6} lg={4}>
              <TextField
                InputLabelProps={{ shrink: true }}
                helperText={errors?.chapterUrl?.message}
                fullWidth
                error={!!errors?.chapterUrl}
                id="chapterUrl"
                disabled={memberScope !== 'PORTAL_SUPER_ADMIN' && memberScope !== 'PORTAL_ADMIN'}
                placeholder="Enter chapter Chapter Url"
                label={
                  <Typography className="text-dark">
                    Chapter Url <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                {...register("chapterUrl", {
                  required: "Please enter a Chapter Url",
                  pattern: {
                    value: /^[a-zA-Z0-9_-]+$/,
                    message: "Only alphanumeric characters, _, and - are allowed. No spaces or other special characters."
                  },
                  onChange: (e) => handleUrlChange(e.target.value),
                })}
              />
              {fullUrl && (
                <Typography style={{ marginTop: 10, color: "gray" }}>
                  Full URL: <span>{fullUrl}</span>
                </Typography>
              )}
            </Grid>}
            <Grid item xs={12} md={6} lg={4}>
              <Typography className="text-dark" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                Chapter Logo <span className="text-danger">*</span>
              </Typography>
              <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <div
                  style={{
                    width: 120,
                    height: 100,
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "2px solid #ccc",
                    flexShrink: 0,
                    background: "#f0f0f0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {(selectedImage || watch("imageUrl")) ? (
                    <img
                      src={
                        selectedImage
                          ? (selectedImage.startsWith("data:image/")
                            ? selectedImage
                            : `${selectedImage}?t=${new Date().getTime()}`)
                          : watch("imageUrl")
                      }
                      alt="Chapter Logo"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <span style={{ fontSize: 32, color: "#aaa" }}><img src={placeholder} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></span>
                  )}
                </div>
                <div>
                  <Button
                    variant="outlined"
                    component="label"
                    size="small"
                    className="menus-color"
                    style={{ color: "white", whiteSpace: "nowrap" }}
                  >
                    {(selectedImage || watch("imageUrl")) ? "Change Logo" : "Upload Logo"}
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={handleImageFileChange}
                    />
                  </Button>
                  <Typography variant="caption" display="block" style={{ marginTop: 4, color: "#888" }}>
                    Crop to 425x375 ratio.
                  </Typography>
                  {(selectedImage || watch("imageUrl")) && (
                    <Button
                      size="small"
                      variant="text"
                      color="error"
                      style={{ marginTop: 2, padding: 0, minWidth: 0 }}
                      onClick={() => {
                        setSelectedImage(null);
                        setValue("imageUrl", "");
                        setValue("image", "");
                      }}
                    >
                      Remove
                    </Button>
                  )}
                </div>
              </div>
              {errors?.image &&
                <FormHelperText error={!!errors?.image}>{errors?.image?.message}</FormHelperText>
              }
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Typography className="text-dark" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                Description
              </Typography>
              <Editor
                value={descriptionText}
                onTextChange={(e) => setDescriptionText(e.htmlValue || "")}
                style={{ height: "150px" }}
                placeholder="Enter description"
              />
            </Grid>

            <Grid item xs={12} md={6} lg={12}>
              <Button variant="contained" className="menus-color" onClick={addRoleDetails}>
                Add Office Bearers
              </Button>
            </Grid>

            {fields.map((details, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} md={6} lg={4} className="d-flex justify-content-between">
                  <Controller className='w-100' rules={{ required: "Please select role of the office bearer" }} control={control} name={`roleDetails.${index}.role`} render={({ field, fieldState }) => (
                    <FormControl className="w-100">
                      <InputLabel id='state-label'>
                        <span className="text-dark">Role</span>
                        <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Select
                        id="State"
                        labelId="state-label"
                        fullWidth
                        label={<span className="text-black">Role<span className="text-danger">*</span></span>}
                        value={field?.value || ""}
                        onChange={(e) => {
                          field.onChange(e.target.value)
                        }}
                        error={!!fieldState.error}
                      >
                        <MenuItem value={'Convenor'}>
                          Convenor
                        </MenuItem>
                        <MenuItem value={'Co-convenor'}>
                          Co-convenor
                        </MenuItem>
                        <MenuItem value={'Executive Member'}>
                          Executive Member
                        </MenuItem>
                      </Select>
                      <FormHelperText className="text-danger">
                        {fieldState?.error?.message}
                      </FormHelperText>
                    </FormControl>
                  )} />
                </Grid>
                <Grid item lg={4} md={6} xs={12}>
                  <Controller
                    control={control}
                    rules={{ required: "Please select an option" }}
                    name={`roleDetails.${index}.salutation`}
                    render={({ field, fieldState }) => (
                      <FormControl fullWidth>
                        <InputLabel id="Salutation" className="text-dark">
                          Salutation
                          <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <Select
                          labelId="Salutation"
                          className="bg-white"
                          id="Salutation"
                          label={
                            <Typography className="text-dark">
                              Salutation <span style={{ color: "red" }}>*</span>
                            </Typography>
                          }
                          value={field.value === "" ? "" : field.value}
                          variant="outlined"
                          onChange={(e) => field.onChange(e.target.value)}
                          error={!!fieldState.error}
                        >
                          {Salutation.map((data, index) =>
                          (
                            <MenuItem key={data.Name} value={data.id}>
                              {data.Name}
                            </MenuItem>
                          )
                          )}
                        </Select>
                        <FormHelperText error={!!fieldState?.error}>{fieldState?.error?.message}</FormHelperText>
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    placeholder="Enter office bearer name"
                    label={
                      <Typography className="text-dark">
                        Name <span style={{ color: "red" }}>*</span>
                      </Typography>
                    }
                    {...register(`roleDetails.${index}.name`, {
                      required: "Please enter a name",
                      minLength: {
                        value: 3,
                        message: "Name must be min length of 3",
                      },
                    })}
                    error={!!errors?.roleDetails?.[index]?.name}
                    helperText={errors?.roleDetails?.[index]?.name?.message}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    placeholder="Enter designation"
                    label={
                      <Typography className="text-dark">
                        Designation <span style={{ color: "red" }}>*</span>
                      </Typography>
                    }
                    {...register(`roleDetails.${index}.designation`, {
                      required: "Please enter a designation",
                    })}
                    error={!!errors?.roleDetails?.[index]?.designation}
                    helperText={errors?.roleDetails?.[index]?.designation?.message}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    placeholder="Enter Institution"
                    label={
                      <Typography className="text-dark">
                        Institution <span style={{ color: "red" }}>*</span>
                      </Typography>
                    }
                    {...register(`roleDetails.${index}.institution`, {
                      required: "Please enter a institution",
                    })}
                    error={!!errors?.roleDetails?.[index]?.institution}
                    helperText={errors?.roleDetails?.[index]?.institution?.message}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter office bearer address"
                    label={
                      <Typography className="text-dark">
                        Complete Address for Communication <span style={{ color: "red" }}></span>
                      </Typography>
                    }
                    {...register(`roleDetails.${index}.address`)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter office bearer pincode"
                    label={
                      <Typography className="text-dark">
                        Pincode <span style={{ color: "red" }}></span>
                      </Typography>
                    }
                    {...register(`roleDetails.${index}.pincode`,
                      {
                        maxLength: {
                          value: 6,
                          message: "Pincode must be exactly 6 digits",
                        },
                      }
                    )}
                    fullWidth
                    error={!!errors?.roleDetails?.[index]?.pincode}
                    helperText={errors?.roleDetails?.[index]?.pincode?.message}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter office bearer email"
                    fullWidth
                    label={
                      <Typography className="text-dark">
                        Email <span style={{ color: "red" }}>*</span>
                      </Typography>
                    }
                    {...register(`roleDetails.${index}.email`,
                      {
                        required: "Please enter a email",
                        pattern: {
                          value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                          message: "Please enter valid email",
                        },
                        validate: (value) => {
                          const roles = getValues('roleDetails')
                          const sameMailRoles = roles.filter(item => item.email === value)
                          if (sameMailRoles.length > 1) {
                            return 'Email ID already exists !!!'
                          }
                          else {
                            return true
                          }
                        },
                        onChange: () => {
                          setValue(`roleDetails.${index}.isAdmin`, false)
                          clearErrors(`roleDetails.${index}.isAdmin`)
                          trigger('roleDetails');
                        }
                      }
                    )}
                    error={!!errors?.roleDetails?.[index]?.email}
                    helperText={errors?.roleDetails?.[index]?.email?.message}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter office bearer mobile number"
                    label={
                      <Typography className="text-dark">
                        Mobile
                      </Typography>
                    }
                    {...register(`roleDetails.${index}.mobile`,
                      {
                        pattern: {
                          value: /^\d{10}$/,
                          message: "Mobile number must be 10 digits",
                        },
                      }
                    )}
                    fullWidth
                    error={!!errors?.roleDetails?.[index]?.mobile}
                    helperText={errors?.roleDetails?.[index]?.mobile?.message}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={4}>
                  <Typography className="text-dark" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                    Photograph
                  </Typography>
                  <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <div
                      style={{
                        width: 90,
                        height: 90,
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: "2px solid #ccc",
                        flexShrink: 0,
                        background: "#f0f0f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {(selectedRoleImage[index] || watch(`roleDetails.${index}.roleImageUrl`)) ? (
                        <img
                          src={
                            selectedRoleImage[index]
                              ? (selectedRoleImage[index].startsWith("data:image/")
                                ? selectedRoleImage[index]
                                : `${selectedRoleImage[index]}?t=${new Date().getTime()}`)
                              : watch(`roleDetails.${index}.roleImageUrl`)
                          }
                          alt="Profile"
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <span style={{ fontSize: 32, color: "#aaa" }}><img src={placeholder} alt="Profile" style={{ width: "100%", height: "100%", objectFit: "cover" }} /></span>
                      )}
                    </div>
                    <div>
                      <Button
                        variant="outlined"
                        component="label"
                        size="small"
                        className="menus-color"
                        style={{ color: "white", whiteSpace: "nowrap" }}
                      >
                        {(selectedRoleImage[index] || watch(`roleDetails.${index}.roleImageUrl`)) ? "Change Photo" : "Upload Photo"}
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={(e) => handleRoleImageFileChange(e, index)}
                        />
                      </Button>
                      <Typography variant="caption" display="block" style={{ marginTop: 4, color: "#888" }}>
                        Crop to 1:1 ratio (drag &amp; zoom to adjust).
                      </Typography>
                      {(selectedRoleImage[index] || watch(`roleDetails.${index}.roleImageUrl`)) && (
                        <Button
                          size="small"
                          variant="text"
                          color="error"
                          style={{ marginTop: 2, padding: 0, minWidth: 0 }}
                          onClick={() => {
                            setSelectedRoleImage((prev) => { const n = [...prev]; n[index] = null; return n; });
                            setValue(`roleDetails.${index}.roleImageUrl`, "");
                          }}
                        >
                          Remove
                        </Button>
                      )}
                    </div>
                  </div>
                </Grid>
                {(!chapterId && (isAdmin === index || watch('roleDetails').every(item => !item.isAdmin))) &&
                  <Grid item xs={12} md={6} lg={4} className="d-flex flex-sm-row flex-column">
                    <FormControl error={!!errors?.roleDetails?.[index]?.isAdmin}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            style={{ color: chapterId ? "grey" : "#1976d2" }}
                            checked={watch(`roleDetails.${index}.isAdmin`)}
                            {...register(`roleDetails.${index}.isAdmin`, {
                              validate: () => {
                                if (watch(`roleDetails.${index}.email`)) {
                                  setValue(`roleDetails.${index}.password`, watch(`roleDetails.${index}.email`).split('@')[0])
                                  return true
                                }
                              }, onChange: (e) => {
                                if (e.target.value) {
                                  setIsAdmin(index)
                                }
                              }
                            })}
                          />
                        }
                        label="Admin"
                      />
                      {errors?.roleDetails?.[index]?.isAdmin && <FormHelperText error={!!errors?.roleDetails?.[index]?.isAdmin}>{errors?.roleDetails?.[index]?.isAdmin?.message}</FormHelperText>}
                    </FormControl>

                  </Grid>}
                {!chapterId && !(isAdmin === index || watch('roleDetails').every(item => !item.isAdmin)) &&
                  <Grid item xs={'none'} lg={4} md={6}></Grid>}
                <Grid item xs={12} md={6} lg={chapterId ? 8 : 4}>
                  {(((!watch(`roleDetails.${index}.isAdmin`) && chapterId) || memberScope === 'PORTAL_SUPER_ADMIN') || !chapterId) && <div className="h-100 w-100 d-flex justify-content-end align-items-center" >
                    <Button
                      variant="contained"
                      style={{ background: "red" }}
                      onClick={() => removeRoleDetails(index)}
                    >
                      <DeleteIcon />
                      Remove
                    </Button>
                  </div>}<br />
                </Grid>
              </React.Fragment>
            ))}
            <Grid item xs={12} lg={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button variant="contained" className="menus-color" type="submit">
                  {chapterId ? "Update" : "Submit"}
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      )
      }
      <ImageCropModal
        open={logoCropModal.open}
        imageSrc={logoCropModal.src}
        outputWidth={425}
        outputHeight={375}
        title="Crop Chapter Logo"
        onCancel={closeLogoCropModal}
        onCrop={(base64) => {
          handleLogoCropApply(base64, (b64) => {
            setSelectedImage(b64);
            setValue("imageUrl", b64);
            setValue("image", b64);
            clearErrors("image");
          });
        }}
      />
      <ImageCropModal
        open={roleCropModal.open}
        imageSrc={roleCropModal.src}
        outputWidth={145}
        outputHeight={145}
        title="Crop Office Bearer Photo"
        onCancel={closeRoleCropModal}
        onCrop={(base64) => {
          handleRoleCropApply(base64, (b64, idx) => {
            setSelectedRoleImage((prevImages) => {
              const newImages = [...prevImages];
              newImages[idx] = b64;
              return newImages;
            });
            setValue(`roleDetails.${idx}.roleImageUrl`, b64);
            setValue(`roleDetails.${idx}.roleImage`, b64);
            clearErrors(`roleDetails.${idx}.roleImage`);
          });
        }}
      />
    </div >
  );
};

export default ChapterForm;
